/* RX currency display
   The store charges in EGP. For visitors who picked another country, prices are shown
   converted into that country's currency (approximate, live rate, cached for 12h).
   Checkout still charges EGP; a note says so in the cart. */
(() => {
  const country = window.rxLocalization?.country || 'EG';
  const CURRENCY = {
    EG: 'EGP', US: 'USD', GB: 'GBP', CA: 'CAD', AU: 'AUD', NZ: 'NZD', JP: 'JPY', HK: 'HKD', SG: 'SGD', MY: 'MYR', KR: 'KRW',
    AT: 'EUR', BE: 'EUR', FI: 'EUR', FR: 'EUR', DE: 'EUR', IE: 'EUR', IT: 'EUR', NL: 'EUR', PT: 'EUR', ES: 'EUR',
    CZ: 'CZK', DK: 'DKK', NO: 'NOK', PL: 'PLN', SE: 'SEK', CH: 'CHF', TR: 'TRY',
    AE: 'AED', SA: 'SAR', KW: 'KWD', QA: 'QAR', BH: 'BHD', OM: 'OMR', JO: 'JOD', LB: 'USD',
  };
  const currency = CURRENCY[country] || 'EGP';
  window.rxCurrency = currency;
  if (currency === 'EGP') return;

  // Fallback EGP -> X rates, used only if the live rate can't be fetched
  const FALLBACK = {
    USD: 0.0205, EUR: 0.0177, GBP: 0.0153, CAD: 0.0284, AUD: 0.0312, NZD: 0.0345, JPY: 3.08, HKD: 0.159, SGD: 0.0266,
    MYR: 0.0868, KRW: 28.4, CZK: 0.445, DKK: 0.132, NOK: 0.207, PLN: 0.0755, SEK: 0.194, CHF: 0.0165, TRY: 0.86,
    AED: 0.0753, SAR: 0.0769, KWD: 0.0063, QAR: 0.0746, BHD: 0.0077, OMR: 0.0079, JOD: 0.0145,
  };
  const KEY = 'rx-egp-rates';
  const ZERO_DECIMAL = ['JPY', 'KRW'];
  const locale = document.documentElement.lang || 'en';
  const MONEY = /(?<![A-Za-z])LE\s?(\d{1,3}(?:,\d{3})*(?:\.\d{1,2})?|\d+(?:\.\d{1,2})?)(?:\s?EGP)?/g;

  let rate = null;
  const fmt = (egp) => {
    const v = egp * rate;
    // Round to a clean retail number: whole units (or hundreds for KRW/JPY)
    const rounded = ZERO_DECIMAL.includes(currency) ? Math.round(v / 100) * 100 : Math.round(v);
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(rounded);
    } catch (e) {
      return `${currency} ${rounded}`;
    }
  };

  const convertNode = (textNode) => {
    const text = textNode.nodeValue;
    if (!text || text.indexOf('LE') === -1) return;
    MONEY.lastIndex = 0;
    if (!MONEY.test(text)) return;
    MONEY.lastIndex = 0;
    const frag = document.createDocumentFragment();
    let last = 0;
    let m;
    while ((m = MONEY.exec(text))) {
      if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
      const egp = parseFloat(m[1].replace(/,/g, ''));
      const span = document.createElement('span');
      span.className = 'rx-money';
      span.dataset.egp = egp;
      span.title = m[0];
      span.textContent = fmt(egp);
      frag.appendChild(span);
      last = m.index + m[0].length;
    }
    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    textNode.parentNode.replaceChild(frag, textNode);
  };

  const SKIP = 'script, style, textarea, input, .rx-money, [data-rx-no-convert]';
  const scan = (root) => {
    if (!root) return;
    if (root.nodeType === 3) {
      if (root.parentElement && !root.parentElement.closest(SKIP)) convertNode(root);
      return;
    }
    if (root.nodeType !== 1 || root.closest(SKIP)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (n.nodeValue.indexOf('LE') !== -1 && !n.parentElement.closest(SKIP) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT),
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(convertNode);
  };

  const notes = () => {
    document.querySelectorAll('.rx-cart__note, .rx-cartpage__note').forEach((el) => {
      if (el.nextElementSibling?.classList.contains('rx-currency-note')) return;
      const p = document.createElement('p');
      p.className = 'rx-currency-note';
      p.textContent = (window.rxStrings?.currency_note || 'Prices in {{ currency }} are approximate. You will be charged in EGP at checkout.').replace('__CUR__', currency).replace('{{ currency }}', currency);
      el.after(p);
    });
  };

  const start = () => {
    scan(document.body);
    notes();
    new MutationObserver((muts) => {
      muts.forEach((mu) => {
        if (mu.type === 'characterData') scan(mu.target);
        mu.addedNodes.forEach(scan);
      });
      notes();
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  };

  const ready = (fn) => (document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn());

  let cached = null;
  try { cached = JSON.parse(localStorage.getItem(KEY)); } catch (e) {}
  if (cached && cached.rates && Date.now() - cached.t < 12 * 3600e3 && cached.rates[currency]) {
    rate = cached.rates[currency];
    ready(start);
    return;
  }
  fetch('https://open.er-api.com/v6/latest/EGP')
    .then((r) => r.json())
    .then((d) => {
      if (!d || !d.rates || !d.rates[currency]) throw new Error('no rate');
      try { localStorage.setItem(KEY, JSON.stringify({ t: Date.now(), rates: d.rates })); } catch (e) {}
      rate = d.rates[currency];
    })
    .catch(() => { rate = FALLBACK[currency]; })
    .finally(() => { if (rate) ready(start); });
})();
